export default function Impressum(){
  return (
    <main role="main">
      <section className="section">
        <h1 className="h1">Impressum</h1>
        <p><strong>Verantwortlich:</strong> DI (FH) Alexander Popovic</p>
        <p><strong>Unternehmen:</strong> SpreadYourWings Werbeagentur</p>
        <p><strong>Adresse:</strong> Heimstättenstrasse 26, 9020 Klagenfurt, Österreich</p>
        <p><strong>E‑Mail:</strong> contact@arkturian.com</p>
      </section>
    </main>
  )
}

